import React from 'react';
import PropTypes from 'prop-types';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { MOBILE_MENU_FROM_LEFT, useLayoutContext } from 'Context/LayoutContext';

const HamburgerMenuWithNewSiteNavigation = ({
  color,
}) => {
  const { setShowMobileMenuFrom, hideBottomNavigation } = useLayoutContext();
  if (!hideBottomNavigation) return null; // They can already see the menu button in the bottom right, no need to add another menu button to the same screen

  return (
    <IconButton
      color={color}
      size={'medium'}
      icon={MenuIcon}
      onClick={() => setShowMobileMenuFrom(MOBILE_MENU_FROM_LEFT)}
      test={'pwa-hamburger-button'}
    />
  );
};

HamburgerMenuWithNewSiteNavigation.defaultProps = {
  color: 'primary',
};

HamburgerMenuWithNewSiteNavigation.propTypes = {
  color: PropTypes.oneOf(['white', 'primary', 'black']),
};

export default HamburgerMenuWithNewSiteNavigation;
